import React, { useState } from 'react'
import isEmpty from 'lodash/isEmpty'

import './search.less'
import { getSearchData } from './util'
import QuickSearch from './components/QuickSearch/QuickSearch'

const Search = () => {
  // const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState()
  const [isQuickSearchLoading, setIsQuickSearchLoading] = useState(false)
  const [quickSearchData, setQuickSearchData] = useState([])

  const handleQuickSearchValueChanged = value => {
    if (isEmpty(value)) {
      setSearchValue()

      return
    }

    setSearchValue(value)
    getSearchData(value, setQuickSearchData, setIsQuickSearchLoading)
  }

  const handleQuickSearchDropdownVisibleChange = isOpen => {
    if (!isOpen) {
      // When the dropdown closes, clear the results
      setQuickSearchData([])
    }
  }

  return (
    <div className="search">
      <QuickSearch
        handleValueChanged={handleQuickSearchValueChanged}
        isLoading={isQuickSearchLoading}
        onDropdownVisibleChange={handleQuickSearchDropdownVisibleChange}
        searchData={quickSearchData}
        value={searchValue}
      />
    </div>
  )
}

export default Search
